export const FIRSTECH_CLIENT_ID = "https://1tech.net/firstechClientId";
export const FIRSTECH_USER_ID = "https://1tech.net/firstechUserId";
export const FIRSTECH_MFA_ENABLED = "https://1tech.net/firstechMFAEnabled";